export interface Feature {
  id: string;
  title: string;
  description: string;
  icon: string;
}

export const features: Feature[] = [
  {
    id: 'feature-1',
    title: '官方正版认证',
    description: '澳门政府合法授权，官方正版app，严格通过安全检测，杜绝恶意软件和病毒风险，保障您的设备与信息安全。',
    icon: 'ri-shield-check-line',
  },
  {
    id: 'feature-2',
    title: '极速流畅体验',
    description: '采用先进技术架构，游戏加载速度快，运行流畅稳定。优化的网络传输协议确保在不同网络环境下均有出色表现。',
    icon: 'ri-flashlight-line',
  },
  {
    id: 'feature-3',
    title: '多元游戏娱乐',
    description: '超过800款精品游戏，涵盖老虎机、桌面游戏、真人视讯、体育竞技等品类，满足各类玩家的娱乐偏好。',
    icon: 'ri-stack-line',
  },
  {
    id: 'feature-4',
    title: '专属会员福利',
    description: '五级会员体系，等级越高福利越丰厚。每日签到奖励、生日礼遇、专属客服、线下活动邀请等多项特权等您享受。',
    icon: 'ri-vip-diamond-line',
  },
  {
    id: 'feature-5',
    title: '安全资金保障',
    description: '银行级SSL加密技术，资金独立托管，多重风控体系，确保您的每一笔交易安全无忧，提现快速到账。',
    icon: 'ri-safe-2-line',
  },
  {
    id: 'feature-6',
    title: '全天候客服支持',
    description: '7×24小时专业客服团队，随时解答您的疑问。多渠道服务覆盖，确保您的每一个问题都能得到及时有效的解决。',
    icon: 'ri-customer-service-2-line',
  },
];